if (!customElements.get('ka-proof-film')) {
  customElements.define('ka-proof-film', class extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.userControlled = false; this.failed = false;
      this.video = this.querySelector('video');
      if (!this.video) return;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.inView = false;
      this.video.muted = true;
      this.video.loop = true;
      const takeControl = () => { this.userControlled = true; this.video.loop = false; };
      this.video.addEventListener('click', takeControl, options);
      this.video.addEventListener('keydown', event => {
        if ([' ', 'Enter', 'ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight', 'Home', 'End', 'm', 'k'].includes(event.key)) takeControl();
      }, options);
      this.video.addEventListener('volumechange', () => { if (!this.video.muted) takeControl(); }, options);
      this.video.addEventListener('error', () => { this.failed = true; }, options);
      this.motion.addEventListener('change', () => this.updatePlayback(), options);
      document.addEventListener('visibilitychange', () => this.updatePlayback(), options);
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(([entry]) => {
          this.inView = entry.isIntersecting;
          this.updatePlayback();
        }, { threshold: 0.25 });
        this.observer.observe(this);
      }
    }
    updatePlayback() {
      if (this.userControlled || this.failed) return;
      if (!this.inView || document.hidden || this.motion.matches || navigator.connection?.saveData) {
        this.video.pause();
        return;
      }
      this.video.play().catch(() => { /* Native controls remain available if autoplay is blocked. */ });
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.abort = null;
      this.observer?.disconnect();
      this.video?.pause();
    }
  });
}

